<template>
  <CMultiSelectNative
    v-bind="$attrs"
    :options="normalizedOptions"
    :value="selected"
    :placeholder="searchPlaceholder || placeholder"
    :search-no-results-label="optionsEmptyPlaceholder"
    :selection-type="selectionType"
    @change="onChange"
  />
</template>

<script>
import { CMultiSelect } from '@coreui/vue-pro'

export default {
  name: 'CMultiSelect',
  inheritAttrs: false,
  components: {
    CMultiSelectNative: CMultiSelect,
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, Array],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    selection: {
      type: Boolean,
      default: true,
    },
    inline: Boolean,
    optionsEmptyPlaceholder: String,
    searchPlaceholder: String,
    placeholder: String,
    selectionType: {
      type: String,
      default: 'tags',
    },
  },
  computed: {
    normalizedOptions() {
      return (this.options || []).map(option => {
        if (option && option.text !== undefined && option.label === undefined) {
          return { ...option, label: option.text }
        }
        return option
      })
    },
  },
  methods: {
    onChange(data) {
      const values = (data || []).map(option => option.value)
      this.$emit('update', values)
      this.$emit('update:selected', values)
      this.$emit('update:value', values)
    },
  },
}
</script>
